import { Button, Dialog, DialogActions, DialogTitle, Typography, Stack, Box } from "@mui/material";
import { DeleteRounded } from "@mui/icons-material";
import { useHistory, useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../../../../../shell/store/types";
import { ContentItem } from "../../../../../../../../shell/services/types";
import { useDeleteContentItemMutation, useGetContentModelItemsQuery } from "../../../../../../../../shell/services/instance";
import { useTranslation } from "react-i18next";
type DuplicateItemProps = {
  onClose: () => void;
};
export const DeleteItemDialog = ({
  onClose
}: DuplicateItemProps) => {
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const {
    modelZUID,
    itemZUID
  } = useParams<{
    modelZUID: string;
    itemZUID: string;
  }>();
  const history = useHistory();
  const item = useSelector((state: AppState) => state.content[itemZUID] as ContentItem);
  const {
    data: modelItems
  } = useGetContentModelItemsQuery({
    modelZUID
  }, {
    skip: !modelZUID
  });
  const [deleteContentItem, {
    isLoading
  }] = useDeleteContentItemMutation();
  const handleRedirectBlockItem = () => {
    if (modelItems?.length - 1 <= 0) {
      history.push("/blocks");
    } else {
      history.push(`/blocks/${modelZUID}`);
    }
  };
  return <Dialog open fullWidth maxWidth={"xs"} onClose={onClose} data-sentry-element="Dialog" data-sentry-component="DeleteItemDialog" data-sentry-source-file="DeleteItemDialog.tsx">
      <DialogTitle data-sentry-element="DialogTitle" data-sentry-source-file="DeleteItemDialog.tsx">
        <Box sx={{
        backgroundColor: "red.100",
        borderRadius: "100%",
        width: "40px",
        height: "40px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        mb: 1.5
      }} data-sentry-element="Box" data-sentry-source-file="DeleteItemDialog.tsx">
          <DeleteRounded color="error" data-sentry-element="DeleteRounded" data-sentry-source-file="DeleteItemDialog.tsx" />
        </Box>
        <Stack data-sentry-element="Stack" data-sentry-source-file="DeleteItemDialog.tsx">
          {t("content.itemEditDeleteContentItemTitle")}
          {":"}
          <Typography variant="inherit" fontWeight={600} data-sentry-element="Typography" data-sentry-source-file="DeleteItemDialog.tsx">
            {item?.web?.metaTitle || item?.web?.metaLinkText}
          </Typography>
        </Stack>
        <Typography variant="body2" color="text.secondary" sx={{
        mt: 1
      }} data-sentry-element="Typography" data-sentry-source-file="DeleteItemDialog.tsx">
          {t("content.itemEditDeleteContentItemDescription")}
        </Typography>
      </DialogTitle>
      <DialogActions data-sentry-element="DialogActions" data-sentry-source-file="DeleteItemDialog.tsx">
        <Button color="inherit" onClick={onClose} data-sentry-element="Button" data-sentry-source-file="DeleteItemDialog.tsx">
          {t("common.cancel")}
        </Button>
        <Button data-cy="DeleteContentItemConfirmButton" variant="contained" color="error" onClick={() => {
        deleteContentItem({
          modelZUID: modelZUID,
          itemZUID: itemZUID
        }).then(() => {
          /**
           * Remove the item from the store before redirecting
           */
          dispatch({
            type: "REMOVE_ITEM",
            itemZUID
          });
          if (history.location.pathname.includes("blocks")) {
            handleRedirectBlockItem();
          } else {
            history.push(`/content/${modelZUID}`);
          }
        });
      }} loading={isLoading} data-sentry-element="Button" data-sentry-source-file="DeleteItemDialog.tsx">
          {t("content.itemEditDeleteItem")}
        </Button>
      </DialogActions>
    </Dialog>;
};